import { lazy } from 'react';

export const userProfileModalComponentByType = {
  UNFOLLOW: lazy(() =>
    import('./Unfollow/UnfollowModalContainer').then((module) => ({
      default: module.UnfollowModalContainer,
    })),
  ),
  CREATE_USER_PROFILE: lazy(() =>
    import('./CreateProfile/CreateProfileModalContainer').then((module) => ({
      default: module.CreateProfileModalContainer,
    })),
  ),
} as const satisfies Record<string, unknown>;
